import gsap from 'gsap'
import SplitText from 'gsap/dist/SplitText'

import {
  getScrollTriggerTimelineOptions,
  getTimelineParallaxOptions
} from './shared'
import { Animation } from '@/types'

export const singleParagraphAnimation = ({
  node,
  context,
  conditions,
  reverse
}: Animation) => {
  if (conditions?.isSmall) return

  const selector = context?.selector || gsap.utils.selector(node)

  /**
   * references
   */
  const column = selector('[data-motion-paragraph-col]')
  const paragraph = selector('[data-motion-paragraph]')
  const variant = paragraph[0]?.getAttribute('data-motion-variant')
  const splitParagraph = new SplitText(paragraph, { type: 'words' })

  /**
   * parallax animation
   */
  const parallax = gsap
    .timeline({ ...getTimelineParallaxOptions(node) })
    .fromTo(
      column,
      { xPercent: variant === 'large' ? 30 : 50 },
      { xPercent: variant === 'large' ? -30 : -50 }
    )

  /**
   * reveal animation
   */
  const timeline = gsap
    .timeline({
      ...getScrollTriggerTimelineOptions(node, reverse),
      defaults: {
        ease: 'power1.out',
        duration: 1.4
      },
      onComplete: () => {
        if (reverse) return
        splitParagraph.revert()
      }
    })
    .from(splitParagraph.words, {
      opacity: 0.15,
      color: '#E5B273',
      stagger: { amount: 0.6 }
    })

  /**
   * revert
   */
  return () => {
    timeline?.kill()
    parallax?.kill()
    splitParagraph.revert()
  }
}
